export default __webpack_public_path__ + "static/media/house-icon.044e009c.svg";